import { useToast } from '@ais-ui/ui-core';
import React, { useState } from 'react';

import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { useScheduleMessage, useShapeFetch } from '@ais-ui/api';
import { mutateCallbacks } from '../../utils/mutateCallbacks';
import { useLocalization } from '@ais-ui/locale-management';
import {
  convertScheduleMessageValuesToBackend,
  scheduleMessageFormSchema,
  ScheduleMessageFormValues,
} from './scheduleMessageForm';
import { ScheduleMessageDialog } from './ScheduleMessageDialog';

interface ScheduleMessageProps {
  setShowDialog: (showDialog: boolean) => void;
}

export const CreateMessageSchedule = ({
  setShowDialog,
}: ScheduleMessageProps) => {
  const { messages } = useLocalization();
  const { mutate } = useScheduleMessage();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const shapeFetch = useShapeFetch();
  const { toast } = useToast();

  const form = useForm<ScheduleMessageFormValues>({
    resolver: zodResolver(scheduleMessageFormSchema),
    defaultValues: {
      enabled: true,
      messageType: 'safety',
      noticeType: undefined,
      action: undefined,
      message: '',
      sender: undefined,
      shapeId: '',
      linkShapeToShipPosition: false,
      name: '',
      pss: [],
      schedule: [],
      broadcastInterval: '00:15:00',
      selectedGroups: [],
    },
  });

  const onScheduleMessage = async (data: ScheduleMessageFormValues) => {
    let shape;
    if (data.shapeId) {
      shape = await shapeFetch(data.shapeId);
    }

    const backendValues = convertScheduleMessageValuesToBackend(data, shape);

    setIsSubmitting(true);

    const callBacks = mutateCallbacks(
      toast,
      messages,
      'create',
      'message schedule',
      setIsSubmitting,
      setShowDialog
    );

    mutate({ messageSchedulePutRequest: backendValues }, callBacks);
  };

  return (
    <ScheduleMessageDialog
      form={form}
      onSubmit={onScheduleMessage}
      mutateType="create"
      isSubmitting={isSubmitting}
      setShowOuterDialog={setShowDialog}
    ></ScheduleMessageDialog>
  );
};
